import React, { useState } from 'react';
import { Search, Filter } from 'lucide-react';
import ProductCard from '../components/ProductCard';
import { useProducts } from '../contexts/ProductContext';
const Products: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const {
    products
  } = useProducts();
  // Dynamically generate categories from all products
  const categories = Array.from(new Set(products.map(product => product.category))).sort();
  // Filter products based on search term and category
  const filteredProducts = products.filter(product => {
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) || product.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === '' || product.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-178">
        {/* Page Header */}
        <div className="mb-8" data-id="element-179">
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-180">
            Dietitian-Approved Products
          </h1>
          <p className="mt-2 text-lg text-gray-600" data-id="element-181">
            Browse our collection of nutrition products and services reviewed by
            registered dietitians.
          </p>
        </div>
        {/* Search and Filters */}
        <div className="mb-8" data-id="element-182">
          <div className="flex flex-col md:flex-row gap-4" data-id="element-183">
            <div className="flex-grow" data-id="element-184">
              <div className="relative rounded-md shadow-sm" data-id="element-185">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-186">
                  <Search className="h-5 w-5 text-gray-400" data-id="element-187" />
                </div>
                <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm" placeholder="Search products..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-188" />
              </div>
            </div>
            <div className="w-full md:w-64" data-id="element-189">
              <div className="relative rounded-md shadow-sm" data-id="element-190">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-191">
                  <Filter className="h-5 w-5 text-gray-400" data-id="element-192" />
                </div>
                <select className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm" value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} data-id="element-193">
                  <option value="" data-id="element-194">All Categories</option>
                  {categories.map(category => <option key={category} value={category} data-id="element-195">
                      {category}
                    </option>)}
                </select>
              </div>
            </div>
          </div>
        </div>
        {/* Results Count */}
        <div className="mb-6" data-id="element-196">
          <p className="text-sm text-gray-500" data-id="element-197">
            Showing {filteredProducts.length}{' '}
            {filteredProducts.length === 1 ? 'product' : 'products'}
          </p>
        </div>
        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-198">
          {filteredProducts.length > 0 ? filteredProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-199" />) : <div className="col-span-3 py-12 text-center" data-id="element-200">
              <p className="text-gray-500 text-lg" data-id="element-201">
                No products found. Try adjusting your search.
              </p>
            </div>}
        </div>
      </div>
    </div>;
};
export default Products;